module.exports = __webpack_public_path__ + "img/logoNegro.e55eddd4.png";